import { RootState } from 'store/store';
import { JourneyError } from './types';
import { ERROR_TYPES } from 'pages/ExperienceCanvas/types';
import { getBackendJourneyErrors } from 'helpers/error.helper';

export function getEmailErrorList(state: RootState, refId: string, checkJourneyErrors = true): JourneyError[] {
  const emailState = state.te.email;
  const language = state.settings.previewTextLanguage;
  const email = emailState.byRefId[refId];

  const retVal: JourneyError[] = [];

  if (!email) return [{ type: ERROR_TYPES.ERROR, err: 'Fatal Emil Error' }];
  // TODO: Verify validation tactics
  const hasTemplate = !!email.payload?.template?.[language]?.journeyEmailTemplateId;
  if (!hasTemplate) retVal.push({ type: ERROR_TYPES.INCOMPLETE, err: 'Missing email template' });
  const emailData = email.payload?.template?.[language]?.journeyEmailTemplateData;
  const dataComplete = Object.values(emailData ?? {}).every((v) => !!v);
  if (!emailData || !dataComplete)
    retVal.push({ type: ERROR_TYPES.INCOMPLETE, err: 'Missing template field mappings' });
  if (!checkJourneyErrors) return retVal;
  const beErrors = Array.isArray(state.te.journey.errors) ? state.te.journey.errors : [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { filteredErrors } = getBackendJourneyErrors(beErrors, state, (err: any) => {
    return err.component && err.component === 'email' && err.refId && err.refId === refId;
  });
  retVal.push(...filteredErrors);

  return retVal;
}
